invHdApp.
factory('CustomerField', ['$http', function($http) {
    return {
      all: function() {
        return $http.get('api/customer-fields');
      },
      get: function(id) {
        return $http.get('api/customer-field/' + id);
      },
      delete: function(id) {
        return $http.delete('api/delete-customer-field/' + id);
      },
      save: function(data) {
        return $http.post('api/save-customer-field',data);
      },
      update: function(data) {
        return $http.post('api/update-customer-field',data);
      }
    };
}]);